import { useState, useEffect, useCallback } from 'react';
import {
  getExpenses,
  addExpense as _add,
  updateExpense as _update,
  deleteExpense as _delete,
  getVendorSuggestions,
} from '@/services/expenseService';
import { useAppContext } from '@/context/AppContext';

export function useExpenses(filters = {}) {
  const [expenses, setExpenses]   = useState([]);
  const [loading, setLoading]     = useState(true);
  const [error, setError]         = useState(null);
  const { showToast }             = useAppContext();

  const fetchExpenses = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await getExpenses(filters);
      setExpenses(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  // Stringify filters to avoid infinite re-renders
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(filters)]);

  useEffect(() => {
    fetchExpenses();
  }, [fetchExpenses]);

  const addExpense = useCallback(async (expense) => {
    const id = await _add(expense);
    await fetchExpenses();
    showToast('Expense saved ✓', 'success');
    return id;
  }, [fetchExpenses, showToast]);

  const updateExpense = useCallback(async (id, expense) => {
    await _update(id, expense);
    await fetchExpenses();
    showToast('Expense updated ✓', 'success');
  }, [fetchExpenses, showToast]);

  const deleteExpense = useCallback(async (id) => {
    await _delete(id);
    setExpenses(prev => prev.filter(e => e.id !== id));
    showToast('Expense deleted', 'info');
  }, [showToast]);

  const total = expenses.reduce((sum, e) => sum + e.amount, 0);

  return { expenses, loading, error, total, addExpense, updateExpense, deleteExpense, refetch: fetchExpenses };
}

export function useVendorSuggestions() {
  const [vendors, setVendors] = useState([]);
  useEffect(() => {
    getVendorSuggestions().then(setVendors).catch(() => {});
  }, []);
  return vendors;
}
